import React, { useState } from "react";
import { Grid, Form, Button } from "semantic-ui-react";

function InputParams({ nextStepHandler, prevStepHandler, customClassName }) {
  const [formValues, setFormValues] = useState({
    cnHeight: 10,
    dnHeight: 10,
    channel: "AUTO",
  });
  const options = [
    { key: "a", text: "Auto", value: "AUTO" },
    { key: "f", text: "58.32 (Channel 1)", value: "ch_1" },
    { key: "60.48", text: "60.48 (Channel 2)", value: "ch_2" },
    { key: "62.64", text: "62.64 (Channel 3)", value: "ch_3" },
    { key: "64.80", text: "64.80 (Channel 4)", value: "ch_4" },
  ];

  const onChange = (name, value) => {
    setFormValues({ ...formValues, [name]: value });
  };

  const isValid = () => {
    let returnValue = false;
    if (
      !isNotANumeric(formValues.dnHeight) &&
      !isNotANumeric(formValues.cnHeight)
    ) {
      returnValue = true;
    }
    return returnValue;
  };
  return (
    <Grid className={customClassName}>
      <Grid.Row columns={1}>
        <Grid.Column width={16}>
          <Form>
            <Form.Group widths="equal">
              <Form.Input
                width={4}
                error={isNotANumeric(formValues.dnHeight)}
                onChange={(e, { value }) => onChange("dnHeight", value)}
                label="Default DN height above ground (m)"
                name="dnHeight"
                placeholder="DN Height above ground (m)"
                value={formValues.dnHeight}
              ></Form.Input>
              <Form.Input
                width={4}
                error={isNotANumeric(formValues.cnHeight)}
                onChange={(e, { value }) => {
                  onChange("cnHeight", value);
                }}
                label="Default CN height above ground (m)"
                name="cnHeight"
                placeholder="CN Height above ground (m)"
                value={formValues.cnHeight}
              ></Form.Input>
              <Form.Select
                width={4}
                defaultValue={formValues.channel}
                onChange={(e, { value }) => {
                  onChange("channel", value);
                }}
                label="Channel"
                name="channel"
                options={options}
                placeholder="Channel"
              />
            </Form.Group>
          </Form>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row
        columns={1}
        style={{ paddingRight: "0px", paddingLeft: "29px" }}
      >
        <Grid.Column floated="right" width={3}>
          <div className="fixed-button">
            <Button onClick={prevStepHandler}>Previous</Button>
            <Button
              disabled={!isValid()}
              onClick={() => {
                nextStepHandler(formValues, "parameters");
              }}
            >
              Next
            </Button>
          </div>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}
function isNotANumeric(val) {
  if (val.trim && val.trim() == "") {
    return true;
  } else {
    return isNaN(parseFloat(val * 1));
  }
}

export default InputParams;
